module.exports = {
	ERROR_PASSWORD_EMPTY: 'Полето за парола не трябва да е празно.',
	ERROR_REPEAT_PASSWORD_EMPTY:
		'Полето за повторната парола не трябва да е празно.',
	ERROR_PASSWORD_MISMATCH: 'Двете пароли трябва да съвпадат.',
	ERROR_MIN_PASSWORD: 'Паролата трябва да е минимум осем символа.',
	ERROR_PASSWORD_CHARS:
		'Паролата трябва да съдържа поне една цифра и поне един специален символ: ~!@#$%^&*()_+`.',
	ERROR_EMAIL_EMPTY: 'Полето за имейл не трябва да е празно.',
	ERROR_EMAIL_INVALID: 'Моля въведете коректен имейл.',
	PASSWORD_RESET_REQUEST_ACCEPTED:
		'Ако съществува потребител с този имейл адрес, изпратихме линк за смяна на паролата.',
	PASSWORD_RESET_SUCCESS: 'Паролата Ви бе променена успешно.',
	PASSWORD_RESET_TOKEN_INVALID:
		'Невалиден или изтекъл линк за смяна на паролата.',

	ERROR_FNAME_EMPTY: 'Моля въведете първото Ви име.',
	ERROR_LNAME_EMPTY: 'Моля въведете фамилното Ви име.',
	ERROR_EGN_EMPTY: 'Моля въведете Вашето ЕГН.',
	ERROR_EGN_INVALID: 'Моля въведете коректен ЕГН.',

	ERROR_ADDRESS_EMPTY: 'Моля въведете Вашия адрес.',

	ERROR_ORGANIZATION_EMPTY: 'Моля изберете организация или "Не членувам".',
	ERROR_PERCENT_EMPTY: 'Моля въведете процент загубено зрение.',

	APPBAR_BUTTON_CATALOGUE: 'Каталог',
	APPBAR_BUTTON_NEW_TITLES: 'Нови заглавия',
	APPBAR_BUTTON_CONTACT: 'Контакт',
	APPBAR_BUTTON_ARCHIVE_MONITOR: 'Архивиране',
	APPBAR_BUTTON_HELP: 'Помощ',
	APPBAR_BUTTON_REGISTRATION: 'Регистрация',
	APPBAR_BUTTON_LOGIN: 'Вход',
	APPBAR_BUTTON_LOGOUT: 'Изход',
	APPBAR_BUTTON_MY_BOOKS: 'Моите книги',
	APPBAR_BUTTON_PROFILE: 'Профил',

	APPBAR_BUTTON_SYSTEM: 'Система',

	APPBAR_LOGO: 'Лого ССБ',
	APPBAR_SITE_TITLE: 'Заглавие на сайта',

	COLOR_ALTS: {
		BLACK_ON_WHITE: 'черно на бял фон едно от шест',
		WHITE_ON_BLACK: 'бяло на черен фон две от шест',
		YELLOW_ON_BLACK: 'жълто на черен фон три от шест',
		BLACK_ON_YELLOW: 'черно на бял фон четири от шест',
		WHITE_ON_BLUE: 'бяло на син фон пет от шест',
		BLUE_ON_WHITE: 'синьо на бял фон шест от шест'
	},

	DOWNLOAD_BUTTON: 'Изтегли',
	PLAY_PAUSE_BUTTON: 'Пусни/спри',

	LP_HEADER: 'Аудио библиотека',
	LP_WELCOME: ' Добре дошли в нашия сайт',
	LP_TERMS_MESSAGE:
		'Моля, запознайте се с правилата за ползване на аудио библиотеката.',
	LOGINFORM: {
		FIELD_REQUIRED: 'Задължително поле',
		HEADER_MESSAGE: 'Вход в системата',
		ERROR_INVALID_CREDENTIALS: 'Грешно потребителско име или парола.',
		ERROR_ACCOUNT_DISABLED: 'Профилът Ви е деактивиран.',
		ERROR_ACCOUNT_NOT_APPROVED:
			'Профилът Ви все още не е одобрен за достъп до сайта.',
		ERROR_EMAIL_NOT_VERIFIED:
			'Моля потвърдете имейл адреса си и опитайте отново.',
		ERROR_GENERIC:
			'Грешка при влизането в системата. Моля опитайте отново.',
	},
	FORGOT_PASSWORD: {
		HEADER_MESSAGE: 'Забравена парола',
		DESCRIPTION:
			'Въведете имейл адреса си и ще Ви изпратим линк за задаване на нова парола.',
		SUBMIT_BUTTON: 'Изпрати линк',
		BACK_TO_LOGIN: 'Към вход',
		ERROR_GENERIC:
			'Възникна проблем при изпращането на линка. Моля опитайте отново.',
	},
	RESET_PASSWORD: {
		HEADER_MESSAGE: 'Нова парола',
		DESCRIPTION: 'Въведете новата си парола два пъти и я запазете.',
		SUBMIT_BUTTON: 'Запази новата парола',
		BACK_TO_LOGIN: 'Към вход',
		INVALID_TOKEN:
			'Невалиден или изтекъл линк за смяна на паролата. Поискайте нов линк.',
	},
	REG: {
		HEADER_MESSAGE: 'Регистрация',
		FIELD_REQUIRED: 'Задължително поле',
		FIELD_INVALID: 'Невалидни данни',
		PASSWORDS_MISMATCH: 'Паролите не са еднакви',
		INVALID_NUMBER: 'Невалидно число!',
		USER_SAVE_FAILED:
			'Грешка при запазването на потребителя, моля опитайте отново.',
		USER_REGISTRATION_FAILED:
			'Грешка при регистрирането на потребителя, моля опитайте отново.',
		IMAGE_UPLOAD_USER_NOT_FOUND: 'Грешни параметри.',
		IMAGE_UPLOAD_SAVE_FAILED:
			'Грешка при изпращането на документа, моля опитайте отново.',
	},
	REGDONE: {
		HEADER_MESSAGE: 'Регистрация',
		REGISTRATION_SUCCESS: 'Регистрацията Ви бе приета успешно',
		REGISTRATION_SUCCESS_SUB_MESSAGE:
			'Моля изчакайте одобрението на администратора - ще получите уведомление на имейла Ви.',
		REGISTRATION_FAILURE: 'Регистрацията Ви бе неуспешна',
		REGISTRATION_FAILURE_SUB_MESSAGE:
			'Възникнаха проблеми с регистрацията Ви, и тя не бе приета успешно. Моля опитайте отново по-късно.',
	},

	AUTH_LOGIN_ERROR_MESSAGE:
		'Грешка при влизането в системата, моля проверете потребителя и паролата Ви',
	AUTH_LOGOUT_SUCCESS_MESSAGE: 'Вие излязохте от системата успешно.',
};
